import api from "../Api";
import { BaseService } from "../BaseService";

const URL = "chat-highlight";

export class ChatHighlightsService extends BaseService {
  async list(): Promise<any[]> {
    try {
      return this.handleResponse(await api.get(`${URL}/list`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async create(params: any): Promise<any> {
    try {
      if (params.loom_url) {
        const data = new FormData();
        data.append("title", params.title);
        data.append("loom_url", params.loom_url);
        if (params.description) data.append("description", params.description);
        return this.handleResponse(
          await api.post(`${URL}/create`, data, {
            headers: { "Content-Type": "multipart/form-data" },
          })
        );
      }

      if (params.youtube_url) {
        const data = new FormData();
        data.append("title", params.title);
        data.append("youtube_url", params.youtube_url);
        if (params.description) data.append("description", params.description);
        return this.handleResponse(
          await api.post(`${URL}/create`, data, {
            headers: { "Content-Type": "multipart/form-data" },
          })
        );
      }

      const data = new FormData();
      if (params.title) data.append("title", params.title);
      if (params.description) data.append("description", params.description);
      if (params.file instanceof File) data.append("file", params.file);
      return this.handleResponse(
        await api.post(`${URL}/create`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        })
      );
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async update(id: number, params: any): Promise<any> {
    try {
      if (params.loom_url) {
        const data = new FormData();
        data.append("title", params.title);
        data.append("loom_url", params.loom_url);
        if (params.description) data.append("description", params.description);
        return this.handleResponse(
          await api.put(`${URL}/update/${id}`, data, {
            headers: { "Content-Type": "multipart/form-data" },
          })
        );
      }

      if (params.youtube_url) {
        const data = new FormData();
        data.append("title", params.title);
        data.append("youtube_url", params.youtube_url);
        if (params.description) data.append("description", params.description);
        return this.handleResponse(
          await api.put(`${URL}/update/${id}`, data, {
            headers: { "Content-Type": "multipart/form-data" },
          })
        );
      }

      const data = new FormData();
      if (params.title) data.append("title", params.title);
      if (params.description !== undefined) data.append("description", params.description ?? "");
      if (params.file instanceof File) data.append("file", params.file);
      return this.handleResponse(
        await api.put(`${URL}/update/${id}`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        })
      );
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async activate(id: number): Promise<any> {
    try {
      return this.handleResponse(await api.patch(`${URL}/activate/${id}`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async deactivate(id: number): Promise<any> {
    try {
      return this.handleResponse(await api.patch(`${URL}/deactivate/${id}`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async delete(id: number): Promise<any> {
    try {
      return this.handleResponse(await api.delete(`${URL}/delete/${id}`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async getActive(): Promise<any> {
    try {
      return this.handleResponse(await api.get(`${URL}/active`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async getActiveForce(): Promise<any> {
    try {
      return this.handleResponse(await api.get(`${URL}/active/force`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async dismiss(id: number): Promise<any> {
    try {
      return this.handleResponse(await api.post(`${URL}/dismiss/${id}`));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }
}
